import { createMmWsAction } from '@skynet/data-ws-mm';

import type { BalanceAlertDirection, BalanceAlertRule } from './types';
import { BalanceAlertRulesCommands } from './types';

/** The fields of a rule a user edits; everything but the first four is optional on the wire. */
type EditableRuleFields = Pick<
  BalanceAlertRule,
  | 'token'
  | 'tokenLimit'
  | 'enabled'
  | 'sendToOwners'
  | 'usersToNotify'
  | 'telegramGroupsToNotify'
  | 'enabledAccountFilter'
  | 'keyWordsAccountFilter'
  | 'idAccountFilter'
  | 'direction'
  | 'compareInUSD'
  | 'availableOnly'
  | 'showAllAssets'
>;

export interface AddBalanceAlertRulePayload extends Partial<EditableRuleFields> {
  projectID: number;
  token: string;
  /** A positive integer. */
  tokenLimit: number;
  direction: BalanceAlertDirection;
}

export const addBalanceAlertRule = createMmWsAction<
  AddBalanceAlertRulePayload,
  AddBalanceAlertRulePayload
>('balanceAlertRules/addBalanceAlertRule', (data) => ({
  command: BalanceAlertRulesCommands.AddBalanceAlertRule,
  ...data,
}));

/**
 * Only the sent fields change. To clear a filter send an empty array, never `null`.
 */
export interface UpdateBalanceAlertRulePayload extends Partial<EditableRuleFields> {
  projectID: number;
  ruleID: number;
}

export const updateBalanceAlertRule = createMmWsAction<
  UpdateBalanceAlertRulePayload,
  UpdateBalanceAlertRulePayload
>('balanceAlertRules/updateBalanceAlertRule', (data) => ({
  command: BalanceAlertRulesCommands.UpdateBalanceAlertRule,
  ...data,
}));

export interface ToggleBalanceAlertRulePayload {
  projectID: number;
  ruleID: number;
  enabled: boolean;
}

/** The enable switch: an `UpdateBalanceAlertRule` the slice tracks apart from an edit. */
export const toggleBalanceAlertRule = createMmWsAction<
  ToggleBalanceAlertRulePayload,
  ToggleBalanceAlertRulePayload
>('balanceAlertRules/toggleBalanceAlertRule', (data) => ({
  command: BalanceAlertRulesCommands.UpdateBalanceAlertRule,
  ...data,
}));

export interface DeleteBalanceAlertRulePayload {
  projectID: number;
  ruleID: number;
}

export const deleteBalanceAlertRule = createMmWsAction<
  DeleteBalanceAlertRulePayload,
  DeleteBalanceAlertRulePayload
>('balanceAlertRules/deleteBalanceAlertRule', (data) => ({
  command: BalanceAlertRulesCommands.DeleteBalanceAlertRule,
  ...data,
}));
